import { formatToDate } from 'brazilian-values'

import { Flex, FloraTypography } from '@grupoboticario/flora-react'

import { formatCurrency } from '@/utils/format/formatCurrency'
import { parseLocalDate } from '@/utils/format/parseLocalDate'

import { FutureMovementRow } from '../ExtractPoints/ExtractPoints.types'
import * as S from './BenefitsToReceive.styles'

const getTextByMovementType = (movementType: string) => {
  return (
    {
      CASHBACK: 'Cashback',
      BONUS: 'Bonificação',
      BIRTHDAY_CAMPAIGN: 'Campanha de aniversário'
    }[movementType] || 'Bonificação'
  )
}

const BenefitsToReceive = ({ futureEvents }: { futureEvents?: FutureMovementRow[] }) => {
  const creditEvents = futureEvents?.filter((row) => row?.operationType === 'CREDIT')

  return (
    <Flex css={S.containerCss} direction="column" gap="$4">
      <FloraTypography fontSize="bodyLargeShort">Benefício a receber</FloraTypography>
      {creditEvents?.map((row) => {
        return (
          <Flex
            css={S.creditEventCardCss}
            direction="row"
            gap="$2"
            justify="space-between"
            key={`${row?.createdAt}${row?.movementId}`}
          >
            <Flex align="center" gap="$4">
              <FloraTypography css={S.auxiliarTextCss} fontSize="exceptionsAuxiliar">
                {formatToDate(new Date(row?.eventDate))}
              </FloraTypography>

              <FloraTypography fontSize="bodyLargeStandard">{getTextByMovementType(row?.movementType)}</FloraTypography>
            </Flex>
            <Flex align="center" gap="$4">
              <FloraTypography fontSize="bodyLargeShort">
                + {row?.amountPoint} pontos = {formatCurrency(row?.payment?.total || row?.amountValue || 0)}
              </FloraTypography>

              <FloraTypography fontSize="exceptionsAuxiliar" css={S.auxiliarTextCss}>
                Disponível em {parseLocalDate(row?.availableFrom)}
              </FloraTypography>
            </Flex>
          </Flex>
        )
      })}
    </Flex>
  )
}

export default BenefitsToReceive
